const baseURL = process.env.REACT_APP_BASE_URL;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseURL,
};